import React, { Component } from "react";
import { Link, NavLink } from "react-router-dom";
import Topbar from "../topBar";
import Sidebar from "../sideBar";
import Cookies from "universal-cookie";
import  Swal  from "sweetalert2/dist/sweetalert2";

import { ADD_CATEGORY, DASHBOARD, EDIT_CATEGORY } from "../../constants/url";
import { ERR_ALERT_TITLE, ERR_GETTING,ERR_POSTING } from "../../constants/alertMessage";
import { Button, Modal } from "@mui/material"; // Import MUI components
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material"; // Import MUI components
import { privateApiCall } from "../../api/privateApi";

const cookies = new Cookies();

class Category extends Component {
  constructor() {
    super();
    window.postMessage("renderTable", "*");
    this.state = {
      data: [],
      showModal: false,
      deleteId: "",
    };
  }

  componentDidMount() {
  const requestUrl = `${ADD_CATEGORY}/?token=${cookies.get("agritech_token")}`
  privateApiCall(requestUrl,"GET")
      .then(
        (res) => {
          const k = 1;

          for (let i = 0; i < res.data.length; i++) {
            res.data[i].sno = k + +i;
          }

          this.setState({ data: res.data });
        },
        (err) => {
          Swal.fire({
            title: `${ERR_ALERT_TITLE}`,
            icon: `${ERR_GETTING}`,
            allowOutsideClick: false,
            showCancelButton: false,
            confirmButtonText: "OK",
          });
        }
      );
  }

  iconformat(cell, row) {
    return <img src={cell} style={{ height: "50px" }} alt="category" />;
  }

  handleEdit = (row) => {
    // Navigate to edit category page
    window.location.href=`${EDIT_CATEGORY}/${row._id}`
  };

  handleDelete = (id) => {
    // Show delete confirmation modal
    this.setState({ showModal: true, deleteId: id });
  };

  confirmDelete = (id) => {
    // Delete category
    
  const requestUrl = `/delete_category/${id}/?token=${cookies.get("asia_page_token")}`
privateApiCall(requestUrl,'POST',{})

      .then(() => {
        // Reload data after deletion
        window.location.reload();
      })
      .catch((error) => {
        Swal.fire({
          title: `${ERR_ALERT_TITLE}`,
          icon: `${ERR_POSTING}`,
          allowOutsideClick: false,
          showCancelButton: false,
          confirmButtonText: "OK",
        });
      });
  };

  handleCloseModal = () => {
    // Close modal
    this.setState({ showModal: false, deleteId: "" });
  };

  render() {
    const { data, showModal, deleteId } = this.state;

    return (
      <div id="wrapper">
        <Topbar backgroundColor="#769A0F" />
        <Sidebar />
        <div className="content-page">
          <div className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12">
                  <div className="page-title-box">
                    <h4 className="page-title float-left">Category</h4>
                    <ol className="breadcrumb float-right">
                      <li className="breadcrumb-item">
                        {" "}
                        <NavLink to={DASHBOARD}>Dashboard</NavLink>
                      </li>
                      <li className="breadcrumb-item active">Category</li>
                    </ol>
                    <div className="clearfix"></div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="card-box">
                    <div style={{ width: "98%" }}>
                      <Link
                        to={ADD_CATEGORY}
                        className="btn btn-primary"
                        style={{ float: "left", backgroundColor: "#11abff" }}
                      >
                        Add category
                      </Link>
                      <TableContainer>
                        <Table>
                          <TableHead>
                            <TableRow>
                              <TableCell width="80px">S.No</TableCell>
                              <TableCell width="180px">Category Name</TableCell>
                              <TableCell width="170px">
                                Category Image
                              </TableCell>
                              <TableCell width="80px">Edit</TableCell>
                              <TableCell width="80px">Delete</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {data.map((row, index) => (
                              <TableRow key={index}>
                                <TableCell>{index + 1}</TableCell>
                                <TableCell>{row.name}</TableCell>
                                <TableCell>
                                  <img
                                    src={row.image}
                                    style={{ height: "50px" }}
                                    alt="category"
                                  />
                                </TableCell>
                                <TableCell>
                                  <Button
                                    onClick={() => this.handleEdit(row)}
                                    variant="contained"
                                    color="info"
                                  >
                                    Edit
                                  </Button>
                                </TableCell>
                                <TableCell>
                                  <Button
                                    onClick={() => this.handleDelete(row._id)}
                                    variant="contained"
                                    color="danger"
                                  >
                                    Delete
                                  </Button>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                      <Modal open={showModal} onClose={this.handleCloseModal}>
                        <div className="modal-dialog">
                          <div className="modal-content">
                            <div className="modal-header">
                              <h5 className="modal-title">Warning!</h5>
                              <button
                                type="button"
                                className="btn-close"
                                onClick={this.handleCloseModal}
                              ></button>
                            </div>
                            <div className="modal-body">Are you sure?</div>
                            <div className="modal-footer">
                              <Button
                                onClick={() => this.confirmDelete(deleteId)}
                                variant="contained"
                                color="primary"
                              >
                                Delete
                              </Button>
                              <Button
                                onClick={this.handleCloseModal}
                                variant="contained"
                                color="secondary"
                              >
                                Close
                              </Button>
                            </div>
                          </div>
                        </div>
                      </Modal>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Category;
